import React from 'react';
import { Form } from 'react-bootstrap';
import Helper from './Helper';

interface FormFieldProps {
  /** Текст лейбла или ReactNode (например, "Пароль (оставьте пустым)") */
  label: React.ReactNode;
  /** id поля для связи с лейблом */
  htmlFor?: string;
  /** Опциональная подсказка для поля (иконка ?) */
  helper?: string;
  /** Поле ввода или кастомный контрол */
  children: React.ReactNode;
  /** Дополнительный класс для Form.Group */
  className?: string;
}

/**
 * Поле формы: лейбл + опциональный хелпер + контрол.
 * Единый отступ mb-3 для всех страниц форм.
 */
export const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  helper,
  children,
  className = '',
}) => (
  <Form.Group className={`mb-3 ${className}`.trim()}>
    <Form.Label htmlFor={htmlFor}>{label}</Form.Label>
    {helper && <Helper content={helper} />}
    {children}
  </Form.Group>
);

export default FormField;
